import React, { useContext } from 'react';
import moment from 'moment/moment';
import i18n from '@i18n';
import clsx from 'clsx';
import { formatOdds } from '@/common/client';
import TicketIcon from '@/icons/TicketIcon';
import BetbookContext from 'nike-ui/src/common/BetbookContext';
import { OddsIndicator } from 'nike-ui/src/components/Arrows/OddsIndicator';

export const MANGO = '#ff8000';
export const softBlue = '#5d9cec';
export const disabledGray = 'rgba(0, 0, 0, 0.4)';

export const formattedRelativeTime = time => moment.utc(time).calendar(null, CALENDAR_FORMATTING);
const CALENDAR_FORMATTING = {
    sameDay: '[' + i18n('jsp.homepage.datum.dnes') + '] H:mm',
    nextDay: '[' + i18n('commons.datum.zajtra') + '] H:mm',
    nextWeek: 'dddd',
    lastDay: '[' + i18n('enum.calendar.vcera') + '] H:mm',
    lastWeek: '[' + i18n('LAST_WEEK_OFFER') + '] dddd',
    sameElse: 'DD/MM/YYYY'
};

export const BetCount = ({ betCount }) =>
    betCount ? (
        <span data-atid="event-betCount" className="next-bets">
            +{betCount}
        </span>
    ) : null;

export const TipTable = ({ children, withLabel, result }) => {
    const { isBetbook } = useContext(BetbookContext);

    return (
        <div className={clsx('tip-table', { 'with-label': withLabel, 'collapse betbookShadow': isBetbook && !result })}>
            {children}
        </div>
    );
};

export const TipRow = ({ children }) => <div className="tip-row tip">{children}</div>;

export const TipCell = ({ label, odds, locked, onClick, classes, initialOdds }) => {
    const { isBetbook } = useContext(BetbookContext);
    const editorTip = classes['editorTip'];
    const isWin = classes['win'];
    const isLoss = classes['loss'];

    return (
        <div
            data-atid={locked ? 'state-tip-locked' : 'state-tip'}
            className={clsx('tip-cell', classes)}
            onClick={onClick}
            data-editor-tip={classes['editorTip'] ? true : undefined}
        >
            <div
                className={clsx({
                    win: classes['win'],
                    loss: classes['loss'],
                    overview: classes['overview'],
                    editorTip: classes['editorTip']
                })}
            >
                {classes['on-ticket'] ? <TicketIcon /> : null}
                <Label value={label} />
                {isBetbook && editorTip ? (
                    <BetbookOdds initialOdds={initialOdds} odds={odds} locked={locked} isWin={isWin} isLoss={isLoss} />
                ) : (
                    <NikeOneOdds odds={odds} locked={locked} />
                )}
            </div>
        </div>
    );
};

const NikeOneOdds = ({ odds, locked }) => (locked ? <div className="lock-image" /> : <Odds value={odds} />);

const BetbookOdds = ({ odds, initialOdds, locked, isLoss, isWin }) => {
    if (initialOdds === odds || isLoss || isWin) {
        return locked ? (
            <div className="lock-image" />
        ) : (
            <div className="betbook-odds flex flex-row items-center justify-center">
                <Odds value={initialOdds} />
            </div>
        );
    }
    return locked ? (
        <div className="lock-image" />
    ) : (
        <div className="betbook-odds flex flex-row items-center justify-center">
            <Odds updated value={initialOdds} title={i18n('betbook.init.ticket.odds')} />
            <OddsIndicator initialOdds={initialOdds} odds={odds} />
            <Odds value={odds} title={i18n('betbook.actual.ticket.odds')} />
        </div>
    );
};

const Label = ({ value }) => (value ? typeof value === 'function' ? value() : <small>{value}</small> : null);

const Odds = ({ value, updated, title }) =>
    value ? (
        typeof value === 'function' ? (
            value()
        ) : (
            <span title={title} className={clsx('kurz', { updated })}>
                {formatOdds(value)}
            </span>
        )
    ) : null;

export const LabelCell = ({ children }) => {
    const { isBetbook } = useContext(BetbookContext);
    return (
        <span
            data-atid="state-tip"
            className={clsx('label-cell', {
                'ellipsis label-cell-betbook bg-black-5 c-black-70 px-10 text-extra-bold': isBetbook
            })}
        >
            {children}
        </span>
    );
};
